<template>
  <div>
    <MDBNavbar expand="lg" class="categories">
      <MDBNavbarNav id="mainCategoriesNavbar" collapse="mainCategoriesNavbar"
        class="mb-2 mb-lg-0 align-items-stretch flex-wrap">
        <template v-if="mainCategories.length > 0">
          <MDBNavbarItem v-for="(category, i) in mainCategories" :key="`main_category_${i}`"
            class="text-center categories-link-wrap mb-2">
            <span class="cursor--pointer font-12 categories-link d-flex align-items-center"
              :class="[isActive(category.plainId), { 'categories-link--disabled': isInteractionLocked }]"
              @click="goToCategory(category)" v-html="category.name[currentLocale]">
            </span>
          </MDBNavbarItem>
        </template>
      </MDBNavbarNav>
    </MDBNavbar>
    <div v-if="mainCategory" class="main-category fw-bold">
      <span v-html="mainCategory.name[currentLocale]"></span>
    </div>
  </div>
</template>

<script setup>
import { MDBNavbar, MDBNavbarNav, MDBNavbarItem } from "mdb-vue-ui-kit";
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import TokenService from "@/services/storage.service";

const store = useStore();
const route = useRoute();
const router = useRouter();
const categoryNavigationPending = ref(false);

const currentLocale = computed(() => store.getters.getCurrentLocale);
const categoriesRequestSent = computed(() => store.getters.getCategoriesRequestSent);
const productRequestSent = computed(() => store.getters.getProductRequestSent);
const isInteractionLocked = computed(() =>
  categoriesRequestSent.value || productRequestSent.value || categoryNavigationPending.value
);

const mainCategories = computed(() => {
  return store.state.categories.filter((item) => !item.parent_id);
});

const isActive = (id) => {
  let category = store.state.categories.find(
    (item) => item.id == route.params.id
  );

  return category.parent_id == id || category.plainId == id ? "active" : "";
};

const mainCategory = computed(() => {
  let category = store.state.categories.find(
    (item) => item.id == route.params.id
  );

  let main = mainCategories.value.find(
    (item) => item.plainId == category.parent_id
  );

  return main ? main : category;
});

const goToCategory = async (category) => {
  if (isInteractionLocked.value) {
    return;
  }

  const currentCategoryId = Number(route.params.id);
  const nextCategoryId = Number(category.id);

  if (!category.link && currentCategoryId === nextCategoryId) {
    return;
  }

  categoryNavigationPending.value = true;
  TokenService.setProductPage(1)

  if (category.link) {
    window.location.href = window.location.origin + category.link;
  } else {
    try {
      await router.push({ name: 'shopCategory', params: { id: category.id }, query: { page: 1 } });
    } finally {
      if (!productRequestSent.value) {
        categoryNavigationPending.value = false;
      }
    }
  }
};

watch(productRequestSent, (isPending) => {
  if (!isPending) {
    categoryNavigationPending.value = false;
  }
});

watch(
  () => route.fullPath,
  () => {
    if (!productRequestSent.value) {
      categoryNavigationPending.value = false;
    }
  }
);
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";

.categories {
  padding-top: 0;
  box-shadow: 0 0 0 0 black;
}

.categories-link {
  background: $secondaryGray;
  padding: 10px;
  margin-right: 5px;
  min-height: 100%;
  line-height: 140%;
}

.categories-link--disabled {
  pointer-events: none;
  opacity: 0.6;
}

:deep(.categories-link.router-link-active),
.active {
  background: black;
  color: white;
  font-weight: bold;
}

.main-category {
  margin-top: 25px;
  margin-bottom: 23px;
  font-size: 20px;
}
</style>
